import React, { useState, useEffect, useContext } from "react";
import { Button, Card, Col, Row, Container, Form } from "react-bootstrap";
import medicinedeliveryimg1 from "../../assets/medicinedeliveryimg1.png";
import medicinedeliveryimg2 from "../../assets/medicinedeliveryimg2.png";
import medicinedeliveryimg3 from "../../assets/medicinedeliveryimg3.png";
import medicinedeliveryimg4 from "../../assets/medicinedeliveryimg4.png";
import { FaMoneyBill } from "react-icons/fa6";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import { MedicineData } from "../../env/action";
import { UserContext } from "../../context/UserContext";

const TopSellingMedicine = () => {
  const navigate = useNavigate();
  const { selectedCartItems, setSelectedCartItems } = useContext(UserContext);
  const [quantities, setQuantities] = useState({});
  const [medicines, setMedicines] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const handleNavigate = () => {
    navigate("/medicine/Addtocart");
  };

  const handleIncrement = (id) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: (prev[id] || 0) + 1,
    }));
  };

  const handleDecrement = (id) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: prev[id] > 0 ? prev[id] - 1 : 0,
    }));
  };

  useEffect(() => {
    setLoading(true);
    MedicineData((res) => {
      if (res?.status === 1) {
        setMedicines(res.data);
        if (selectedCartItems?.length > 0) {
          const initialQuantities = {};
          selectedCartItems.forEach((item) => {
            initialQuantities[item.id] = item.quantity;
          });
          setQuantities(initialQuantities);
        }
      } else {
        alert("Error: No data found");
      }
      setLoading(false);
    });
  }, []);

  const filteredMedicines = medicines.filter((item) =>
    item.medicine_name?.toLowerCase().includes(searchQuery.toLowerCase())
  );


  const handleAddToCart = (equipment) => {
    const quantity = quantities[equipment.id] || 0;
    if (quantity === 0) {
      alert("Please select at least 1 quantity before adding to cart");
      return;
    }

    // ensure selectedCartItems is always array
    const currentCart = Array.isArray(selectedCartItems)
      ? [...selectedCartItems]
      : [];

    const existingItemIndex = currentCart.findIndex((item) => item.id === equipment.id);

    if (existingItemIndex >= 0) {
      if (currentCart[existingItemIndex].quantity !== quantity) {
        currentCart[existingItemIndex].quantity = quantity;
      }
    } else {
      currentCart.push({
        id: equipment.id,
        equipment_name: equipment.equipment_name,
        price: equipment.price,
        image: equipment.image,
        quantity,
      });
    }

    setSelectedCartItems(currentCart);
    navigate(`/medicine/Addtocart/`, { state: { currentCart } });

  };

  return (
    <>
      <Container>
        {/* 🔍 Search Bar */}
        <Row className="mb-3">
          <Col md={12} className="my-2">
            <Form.Control
              type="text"
              placeholder="Search Medicine"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </Col>
        </Row>
      </Container>
      <Container>
        <Row className="g-3 mt-4">
          <p className="fs-3 fw-bolder">Top Selling Medicine</p>

          {loading ? (
            <p>Loading...</p>
          ) : filteredMedicines.length === 0 ? (
            <p>No medicines found.</p>
          ) : (
            filteredMedicines.map((medicine) => (
              <Col key={medicine.id} xl={3} lg={6} md={12} sm={12}>
                <Card className="rounded-3 shadow-sm" style={{ width: "100%", height: "auto" }}>
                  <Card.Img
                    variant="top"
                    src={medicine.image}
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                  <Card.Body>
                    <Card.Title className="fw-bolder fs-6">
                      {medicine.medicine_name}
                    </Card.Title>

                    {/* PRICE + COUNTER ROW */}
                    <div className="d-flex justify-content-between align-items-center mt-2">
                      <div className="d-flex align-items-center">
                        <FaMoneyBill className="me-2 text-success" />
                        <Card.Text className="mb-0">
                          <span className="fw-bolder me-2">{medicine.price}</span>
                        </Card.Text>
                      </div>

                      {/* Quantity Counter */}
                      <div className="d-flex align-items-center countr">
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          className="px-2 py-1 fw-bold"
                          onClick={() => handleDecrement(medicine.id)}
                        >
                          –
                        </Button>
                        <span className="mx-2 fw-bold fs-6">
                          {quantities[medicine.id] || 0}
                        </span>
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          className="px-2 py-1 fw-bold"
                          onClick={() => handleIncrement(medicine.id)}
                        >
                          +
                        </Button>
                      </div>
                    </div>

                    {/* Buttons */}
                    <button
                      className="btn w-100 border my-2"
                      style={{ fontSize: "13px" }}
                      onClick={() => handleAddToCart(medicine)}
                    >
                      Add to Cart
                    </button>

                    <button
                      className="btn btn-primary w-100 border"
                      style={{ fontSize: "13px" }}
                      onClick={handleNavigate}
                    >
                      View Cart
                    </button>
                  </Card.Body>
                </Card>
              </Col>
            ))
          )}
        </Row>
      </Container>

    </>
  );
};

export default TopSellingMedicine;
